"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icons;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _icon = require("@site/pattern-library-utils/icon");
/* eslint-disable complexity */
/* eslint-disable max-statements */

const IconWrapper = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "IconWrapper",
  class: "pl-iqnnbej"
});

/**
 * Icon component.
 *
 * @param {Object} props React props
 * @param {string} props.icon Icon
 * @param {string} props.color Icon Color
 * @returns {React.ReactElement} Icon
 * @public
 */

const WIDTH = '40';
const HEIGHT = '40';
function Icons({
  icon = '',
  color
}) {
  const icons = {
    mail: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "mail-open",
      fill: color,
      width: WIDTH,
      height: HEIGHT
    }),
    search: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "search",
      fill: color,
      width: WIDTH,
      height: HEIGHT
    }),
    like: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "thumbs-up",
      fill: color,
      width: WIDTH,
      height: HEIGHT
    }),
    content: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "image-gallery",
      fill: color,
      width: WIDTH,
      height: HEIGHT
    }),
    creditCard: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "credit-card",
      fill: color,
      width: WIDTH,
      height: HEIGHT
    })
  };
  if (!(icon in icons)) return null;
  return /*#__PURE__*/_react.default.createElement(IconWrapper, {
    "data-cy": "icons"
  }, icons[icon]);
}
Icons.propTypes = {
  icon: _propTypes.default.string,
  color: _propTypes.default.string
};